export default {
  FETCH_PROJECT_TAGS_REQUEST: 'FETCH_PROJECT_TAGS_REQUEST',
  FETCH_PROJECT_TAGS_SUCCESS: 'FETCH_PROJECT_TAGS_SUCCESS',
  FETCH_PROJECT_TAGS_FAILURE: 'FETCH_PROJECT_TAGS_FAILURE',
  UPDATE_PROJECT_TAGS_QUERY: 'UPDATE_PROJECT_TAGS_QUERY',
  UPDATE_PROJECT_TAGS_FILTERS: 'UPDATE_PROJECT_TAGS_FILTERS',
  RESET_PROJECT_TAGS: 'RESET_PROJECT_TAGS'
}
